import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./Application/App";
import Navbar from "Application/Components/SalvageWebComponents/Navbar";
import Footer from "Application/Components/SalvageWebComponents/Footer";
import { ErrorBoundary } from "@siba/components";

/**
 * Application rendering component
 */
ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={"/sibasalvage/"}>
            <Navbar />
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
            <Footer />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
);
